import React from "react";
import { Button, useDisclosure, Flex, Spacer } from "@chakra-ui/react";
import { IoAddOutline } from "react-icons/io5";
import { AutoComplete, Form, Modal, TextInput } from "components";
import { SURGEON_ROLES, useOnline } from "duck";
import { Integrate } from "./components";
import {
  FormValues,
  getValidation,
  useCreateCase,
  useCreateOfflineCase
} from "./duck";

const Create: React.FC = () => {
  const online = useOnline();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isEMROpen,
    onOpen: onEMROpen,
    onClose: onEMRClose
  } = useDisclosure();

  const createOnline = useCreateCase();
  const createOfflineCase = useCreateOfflineCase();

  return (
    <>
      <Button onClick={onOpen} leftIcon={<IoAddOutline />}>
        New Case
      </Button>

      {isOpen && (
        <Modal title="Create New Case" onClose={onClose} isOpen>
          <Form<FormValues>
            {...getValidation()}
            onSubmit={online ? createOnline : createOfflineCase}
            display="flex"
            flexDirection="column"
            gridGap={6}
          >
            <TextInput
              name="caseName"
              label="Case Name"
              placeholder="Enter Case Name"
            />

            <AutoComplete.Users
              name="doctor"
              role={SURGEON_ROLES}
              placeholder="Select Doctor"
              label="Doctor"
            />

            <Form.Controls submitText="Save">
              <Flex w="full">
                {online && (
                  <Button
                    onClick={() => {
                      onClose();
                      onEMROpen();
                    }}
                    colorScheme="minor"
                  >
                    Import from EMR
                  </Button>
                )}
                <Spacer />
                <Button
                  color="gray.700"
                  variant="outline"
                  colorScheme="gray"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </Flex>
            </Form.Controls>
          </Form>
        </Modal>
      )}

      {isEMROpen && <Integrate isOpen onClose={onEMRClose} />}
    </>
  );
};

export default Create;
